export const TRUSTPILOT_BUSINESSUNIT_ID = `${process.env.NEXT_PUBLIC_TRUSTPILOT_BUSINESSUNIT_ID}`;
export const TRUSTPILOT_REVIEW_URL = `${process.env.NEXT_PUBLIC_TRUSTPILOT_REVIEW_URL}`;

export const templateIds = Object.freeze({
    mini: '5419b637fa0340045cd0c936',
    medium: '53aa8807dec7e10d38f59f32',
});
